<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <router-link :to="{
          name: 'your-information-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">YOUR INFORMATION</h4>
            <div class="nav-text-center">
              <i class="icon-account vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <router-link :to="{
          name: 'essentials-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">ESSENTIALS</h4>
            <div class="nav-text-center">
              <i class="icon-warning vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <router-link :to="{
          name: 'flights-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">FLIGHTS</h4>
            <div class="nav-text-center">
              <i class="icon-flight vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>

      <b-col v-if="showOnTheGround" class="column-border col-lg card-col col-12">
        <router-link :to="{
          name: 'on-the-ground-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">ON THE GROUND</h4>
            <div class="nav-text-center">
              <i class="icon-on_the_ground vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <router-link :to="{
          name: 'other-services-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">OTHER SERVICES</h4>
            <div class="nav-text-center">
              <i class="icon-airport_parking vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>
    </b-row>
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    HomeLayout,
  },
  data() {
    return {
      showOnTheGround: false,
      loginRes: {},
    };
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      itineraryRaw: "booking/getItineraryRaw",
    }),
  },
  watch: {
    essentialInfoMenu: function () {
      this.checkOnTheGround();
    },
    itineraryRaw: function () {
      this.checkOnTheGround();
    },
  },
  async created() {
    const loginRes = await this.loginOnStart({
      username: this.$route.params.surname,
      bookingNumber: this.$route.params.bookingNumber,
      source: this.$route.params.source,
    });
    this.$emit("loading-bar", false);
    if (!loginRes) {
      this.$router.push("/login");
    }
  },
  async mounted() {
    this.checkOnTheGround();
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
    }),
    checkOnTheGround() {
      if (
        this.essentialInfoMenu.some((el) =>
          [
            "Accommodation",
            "Tour / Cruise",
            "Health & Safety",
            "General Information",
          ].includes(el.title)
        )
      ) {
        this.showOnTheGround = true;
      }
      if (this.itineraryRaw) {
        this.itineraryRaw.itinerary.forEach((day) => {
          if (
            day.data.some(
              (el) =>
                el.essentialInformation &&
                (el.essentialInformation.productEssential.length > 0 ||
                  el.essentialInformation.checkInEssential.length > 0)
            )
          ) {
            this.showOnTheGround = true;
          }
        });
      }
    },
  },
};
</script>